import { signOut } from 'aws-amplify/auth';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const signOutAwait = async () => {
      await signOut();
      navigate('/');
    };
    signOutAwait();
  }, [navigate]);
  return null;
};

export default Logout;
